<div class="text-editor input-wrapper"
     [ngClass]="{'input-wrapper--error': (fc?.errors && fc?.touched)}"
>
  <div *ngIf="label" class="mb-1" >
    <label>
      {{label}}
      <span
        *ngIf="!fc?.value && fc?.errors?.required"
        class="required-asterisk"
      >
        *
      </span>
    </label>
    <ng-content select="[top-right]"></ng-content>
  </div>
  <div class="text-editor__editor">
    <quill-editor [formControl]="fc" [placeholder]="placeholder" #editor [style]="{height: '250px'}">
    </quill-editor>

    <div class="d-none required-label"
         [ngClass]="{'d-block': fc?.touched && fc?.errors?.required}"
    >
      Required field
    </div>
  </div>
</div>
